import { Form } from "react-bootstrap";
const Select = ({ children, important, label, lableRequired, value, id, placeholder, onClick, handleChange, defaultValue, disabled }) => {
    return (
        <>
            <Form.Group>
                <Form.Label className='mb-0'>{label} {important ? <span className="text-danger">*</span> : ""}</Form.Label>
                <Form.Select className="text-secondary text-capitalize" value={value} id={id} disabled={disabled} onClick={onClick} onChange={handleChange} defaultValue={defaultValue}>
                    <option hidden>{placeholder}</option>
                    {children}
                </Form.Select>
            </Form.Group>
        </>
    );
}

export default Select;